<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useGlobalDialogStore } from '@/stores/use-global-dialog-store'

const { globalDialogData, isDialogShow } = storeToRefs(useGlobalDialogStore())
const { closeGlobalDialog, confirmDialog, cancelDialog } =
  useGlobalDialogStore()
</script>

<template>
  <app-modal
    :modal-title="globalDialogData?.title"
    :model-value="isDialogShow"
    :size="'lg'"
    @modal-hidden="closeGlobalDialog"
  >
    <div class="w-100 d-flex justify-content-center">
      {{ globalDialogData?.content }}
    </div>
    <template #footer>
      <!-- 確認對話框模式 -->
      <template v-if="globalDialogData?.showConfirmButton">
        <button
          class="btn btn-outline-secondary"
          type="button"
          :aria-label="$t('Common.AppModal.Cancel')"
          @click="cancelDialog"
        >
          {{ $t('Common.AppModal.Cancel') }}
        </button>
        <button
          class="btn btn-primary"
          type="button"
          :aria-label="$t('Common.AppModal.Confirm')"
          @click="confirmDialog"
        >
          {{ $t('Common.AppModal.Confirm') }}
        </button>
      </template>
      <!-- 一般對話框模式 -->
      <template v-else>
        <button
          class="btn btn-outline-primary"
          type="button"
          :aria-label="$t('Common.AppModal.ClosePopup')"
          @click="closeGlobalDialog"
        >
          {{ $t('Common.AppModal.Close') }}
        </button>
      </template>
    </template>
  </app-modal>
</template>
